module.exports = __webpack_public_path__ + "fonts/Calibre-BoldItalic.2efc6f2b.woff2";